module.exports = __webpack_public_path__ + "img/enarmonisis-logo.b046b867.svg";